import { CellTemplateProps, EditableItem } from '../../../../components/KendoDataGrid/KendoDataGrid.types';
import { ApprovalConfigurationStage } from '../../types';

export interface OptionType {
  id: string
  text: string
}

export interface RequiredRolesOptionType extends OptionType {
  joinedEmployeeIds: string[]
}

export interface ApprovalConfiguration {
  id?: string
  isActive: boolean
  name: string
  description: string
  approvalStages: ApprovalConfigurationStage[]
  documentTypeIds?: string[]
  formRevId: string | undefined
  formDocumentId: string | undefined
  roleCoverage: RoleCoverage
  usedCount: number
  coveredCount?: number
}

export interface EditableApprovalConfiguration extends ApprovalConfiguration, EditableItem {
  documentTypeIds_edit?: OptionType[]
}

export interface CustomCellProps
  extends CellTemplateProps<EditableApprovalConfiguration> {
  dataOptions?: OptionType[]
  onConfigureClick?: (dataItem: ApprovalConfiguration) => void
  onConfigureFieldMapping?: (dataItem: ApprovalConfiguration) => void
  disableDelete?: (dataItem: EditableApprovalConfiguration) => boolean
  onDocumentTypeUpdated?: (value: OptionType[]) => void
}

export const EDIT_FIELDS = ['documentTypeIds_edit', 'roleCoverage', 'summary', 'usedCount'];

export interface ApprovalConfigurationSchemaOptions {
  documentTypeList: OptionType[]
  onConfigureClick: (dataItem: ApprovalConfiguration) => void
  onConfigureFieldMapping: (dataItem: ApprovalConfiguration) => void
  disableDelete: (dataItem: EditableApprovalConfiguration) => boolean
  onDocumentTypeUpdated: (value: OptionType[]) => void
  onCopy: (value: EditableApprovalConfiguration) => void
}

export interface RoleCoverage {
  coveredRoles: OptionType[]
  requiredRoles: RequiredRolesOptionType[]
}

export interface ApprovalConfigurationUsageEntry {
  docId: string
  name?: string
  description: string
  id: string
}

export interface ApprovalConfigurationUsage {
  changeRequestDetails?: ApprovalConfigurationUsageEntry[]
  docRevDetails?: ApprovalConfigurationUsageEntry[]
}

export interface ApprovalConfigurationSaveRequest {
  approvalRequestId?: string
  documentRevisionId?: string
  approvalStages: ApprovalConfigurationStage[]
  name?: string
  description?: string
  id?: string
  isUnassign: boolean
}

export type ApprovalConfigurationUsageType =
  | 'changeRequest'
  | 'documentRevision';

export interface SelectedUsageEntry {
  id: string
  type: ApprovalConfigurationUsageType
}
